import { getEngine } from '../engine/engine';
import { MAX_ZOOM, MIN_ZOOM } from '../gl/view';
import { setZoom, zoomStep } from '../state/actions';
import { useHudStore } from '../state/hud';
import { getActiveDocument, getActiveView, getHistoryView, useAppStore } from '../state/store';
import { Icon } from './components/controls';

function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
  return `${(bytes / 1024 / 1024 / 1024).toFixed(2)} GB`;
}

export function StatusBar() {
  const store = useAppStore();
  const doc = getActiveDocument(store);
  const view = getActiveView(store);
  const history = getHistoryView(store, store.activeDocumentId);
  const cursor = useHudStore((state) => state.cursor);
  const engine = getEngine();

  return (
    <div className="statusbar">
      <div className="statusbar__zoom">
        <button
          type="button"
          className="button button--icon"
          title="Zoom out"
          disabled={!doc}
          onClick={() => zoomStep(-1)}
        >
          <Icon size={12} path="M6 12h12" />
        </button>
        <input
          className="slider statusbar__zoom-slider"
          type="range"
          min={Math.log2(MIN_ZOOM) * 100}
          max={Math.log2(MAX_ZOOM) * 100}
          value={view ? Math.log2(view.zoom) * 100 : 0}
          disabled={!view}
          title="Zoom"
          onChange={(event) => setZoom(2 ** (Number.parseFloat(event.target.value) / 100))}
        />
        <button
          type="button"
          className="button button--icon"
          title="Zoom in"
          disabled={!doc}
          onClick={() => zoomStep(1)}
        >
          <Icon size={12} path="M12 6v12M6 12h12" />
        </button>
        <span className="statusbar__zoom-label">{view ? `${Math.round(view.zoom * 100)}%` : '—'}</span>
      </div>
      <span>{doc ? `${doc.width} × ${doc.height} px` : 'No document'}</span>
      <span>{cursor ? `${Math.round(cursor.x)}, ${Math.round(cursor.y)}` : '—'}</span>
      {doc?.hasSelection && <span>Selection active</span>}
      {store.quickMask && <span>Quick Mask</span>}
      <span className="statusbar__spacer">{store.status}</span>
      <span title="Undo history memory">History: {formatBytes(history.bytes)}</span>
      <span title="GPU texture memory">
        GPU: {engine.available ? formatBytes(engine.totalTextureBytes) : '—'}
      </span>
    </div>
  );
}
